// src/components/ui/common/index.ts
export { default as FormInput } from './FormInput';
export { default as FormButton } from './FormButton';
export { default as FormAlert } from './FormAlert';